class ShopifyItpFormsModal extends window.ShopifyFormsModalBase {
  constructor() {
    super();
    this.form = this.querySelector('[data-itp-forms-form]');
    this.usDistributorYesPanel = this.querySelector('[data-us-distributor-yes-panel]');
    this.contactFields = this.querySelector('[data-contact-fields]');
    this.companyInfoFields = this.querySelector('[data-company-info-fields]');
    this.additionalInfoFields = this.querySelector('[data-additional-info-fields]');
    this.salesModelOptions = this.querySelectorAll('[data-itp-sales-model]');
    this.resaleChannelsPanel = this.querySelector('[data-resale-channels-panel]');
    this.resaleChannelOptions = this.querySelectorAll('[data-itp-resale-channel]');
    this.resaleChannelOtherCheckbox = this.querySelector('[data-itp-resale-channel-other]');
    this.resaleChannelOtherField = this.querySelector('[data-resale-channel-other-field]');
    this.resaleChannelOtherInput = this.querySelector('input[name="resaleChannelOtherText"]');
    this.usDistributorFields = this.querySelectorAll('input[name="usDistributorOrUsOnly"]');
    this.stringFields = [
      'firstName', 'lastName', 'jobTitle', 'businessEmail', 'phone',
      'legalBusinessName', 'dbaNames', 'companyWebsite',
      'addressLine1', 'addressLine2', 'city', 'stateProvince', 'postalCode', 'country',
      'mainIndustry', 'salesTerritory', 'salesRepOrAdditionalInfo',
    ];
    this.booleanFields = ['usDistributorOrUsOnly'];
  }

  connectedCallback() {
    super.connectedCallback();
    this.boundHandleUsDistributorChange = this.handleUsDistributorChange.bind(this);
    this.boundHandleSalesModelChange = this.handleSalesModelChange.bind(this);
    this.boundHandleResaleChannelOtherChange = this.handleResaleChannelOtherChange.bind(this);

    this.usDistributorFields.forEach((input) => {
      input.addEventListener('change', this.boundHandleUsDistributorChange);
    });
    this.toggleUsDistributorPanels();

    this.salesModelOptions.forEach((input) => {
      input.addEventListener('change', this.boundHandleSalesModelChange);
    });

    if (this.resaleChannelOtherCheckbox) {
      this.resaleChannelOtherCheckbox.addEventListener('change', this.boundHandleResaleChannelOtherChange);
    }
  }

  disconnectedCallback() {
    this.usDistributorFields.forEach((input) => {
      if (this.boundHandleUsDistributorChange) {
        input.removeEventListener('change', this.boundHandleUsDistributorChange);
      }
    });
    this.salesModelOptions.forEach((input) => {
      if (this.boundHandleSalesModelChange) {
        input.removeEventListener('change', this.boundHandleSalesModelChange);
      }
    });
    if (this.resaleChannelOtherCheckbox && this.boundHandleResaleChannelOtherChange) {
      this.resaleChannelOtherCheckbox.removeEventListener('change', this.boundHandleResaleChannelOtherChange);
    }
    super.disconnectedCallback();
  }

  handleUsDistributorChange() {
    this.toggleUsDistributorPanels();
  }

  toggleUsDistributorPanels() {
    const value = this.getBooleanFieldValue('usDistributorOrUsOnly');
    const isYes = value === true;
    const isNo = value === false;

    if (this.usDistributorYesPanel) {
      this.usDistributorYesPanel.classList.toggle('hidden', !isYes);
    }

    [this.contactFields, this.companyInfoFields, this.additionalInfoFields].forEach((panel) => {
      if (!panel) return;
      panel.classList.toggle('hidden', !isNo);
      panel.querySelectorAll('input, select, textarea').forEach((input) => {
        input.disabled = !isNo;
      });
    });

    this.toggleResaleChannelsPanel();

    if (this.formFooter) {
      this.formFooter.classList.toggle('hidden', isYes);
    }
  }

  handleSalesModelChange() {
    this.toggleResaleChannelsPanel();
  }

  toggleResaleChannelsPanel() {
    const showValues = new Set(['Direct to end-users', 'Both end-user and dealer sales', 'OEM Part']);
    const shouldShow = Array.from(this.salesModelOptions || []).some(
      (input) => input.checked && showValues.has(input.value)
    );

    if (this.resaleChannelsPanel) {
      this.resaleChannelsPanel.classList.toggle('hidden', !shouldShow);
      this.resaleChannelsPanel.querySelectorAll('input').forEach((input) => {
        input.disabled = !shouldShow;
      });
      if (!shouldShow) {
        this.resaleChannelsPanel.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
          cb.checked = false;
        });
        if (this.resaleChannelOtherInput) this.resaleChannelOtherInput.value = '';
      }
    }

    this.toggleResaleChannelOtherField();
  }

  handleResaleChannelOtherChange() {
    this.toggleResaleChannelOtherField();
  }

  toggleResaleChannelOtherField() {
    const isChecked = !!(this.resaleChannelOtherCheckbox && this.resaleChannelOtherCheckbox.checked);

    if (this.resaleChannelOtherField) {
      this.resaleChannelOtherField.classList.toggle('hidden', !isChecked);
      if (this.resaleChannelOtherInput) {
        this.resaleChannelOtherInput.disabled = !isChecked;
        if (!isChecked) this.resaleChannelOtherInput.value = '';
      }
    }
  }

  resetTransientState() {
    super.resetTransientState();
    this.toggleUsDistributorPanels();
  }

  buildPayload() {
    const payload = super.buildPayload();

    const salesModelValues = Array.from(this.salesModelOptions || [])
      .filter((input) => input.checked)
      .map((input) => input.value);
    if (salesModelValues.length) payload.businessModel = salesModelValues.join('; ');

    const channels = Array.from(this.resaleChannelOptions || [])
      .filter((input) => input.checked)
      .map((input) => input.value);
    if (this.resaleChannelOtherCheckbox && this.resaleChannelOtherCheckbox.checked) {
      const otherText = this.resaleChannelOtherInput ? this.resaleChannelOtherInput.value.trim() : '';
      channels.push(otherText ? `Other: ${otherText}` : 'Other');
    }
    if (channels.length) payload.resaleChannels = channels.join(', ');

    return payload;
  }
}

if (!customElements.get('shopify-itp-forms-modal')) {
  customElements.define('shopify-itp-forms-modal', ShopifyItpFormsModal);
}
